import React from 'react';
import cn from 'clsx';
import { Icon } from '../icon';
import { InfoCircleExclamationIconProps } from '@components-clean/core/icons/info-circle-exclamation-icon/Info-circle-exclamation-icon.interface';

const InfoCircleExclamationIcon = ({
    title,
    dataTestId,
    className,
    tooltipPosition,
    maxWidth,
}: InfoCircleExclamationIconProps) => {
    return (
        <Icon
            dataTestId={dataTestId}
            className={cn(className)}
            title={title}
            icon={['far', 'circle-exclamation']}
            tooltipPosition={tooltipPosition}
            maxWidth={maxWidth}
        />
    );
};

export default InfoCircleExclamationIcon;
